<template>
  <svg fill="none" height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.33594 26.25V11.25L15.3359 3.75L25.3359 11.25V26.25H17.5385V18.4375H13.1108V26.25H5.33594Z"
          fill="currentColor"/>
  </svg>
</template>
